// ========================================
// components/ProtectedRoute.js
// ========================================
// PURPOSE: Protects routes that require authentication
// - Redirects unauthenticated users to login page
// - Shows loading state while checking authentication
// - Displays friendly message when redirecting
// ========================================

import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // State for authentication status
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    // Get stored auth data
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    // Check if token and user exist in localStorage
    if (token && user) {
      setIsAuthenticated(true);
      setUserData(JSON.parse(user));
    } else {
      setIsAuthenticated(false);
    }
    
    setIsChecking(false);
  }, []);

  // Show loading screen while checking authentication
  if (isChecking) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p className="loading-text">Verifying your session...</p>
      </div>
    );
  }
  
  // Not authenticated - redirect to login with message
  if (!isAuthenticated) {
    return <Navigate 
      to="/login" 
      state={{ 
        message: 'Please log in to access your dashboard'
      }} 
      replace 
    />;
  }
  
  // Check if email is verified
 if (userData && !userData.isEmailVerified) {
  return <Navigate to="/verify-prompt" replace />;
}
  
  // Authenticated - render the protected component
  return children;
};

export default ProtectedRoute;